export default __webpack_public_path__ + "static/media/react_styled.c23ef94e.png";